import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Radio, RadioGroup, TextField, Typography, withStyles } from '@material-ui/core';
import { toastr } from 'react-redux-toastr';
import AuthApi from '../../../api/AuthApi';
import { settingsStyles } from '../styles';

function ReportsSettings({ classes, organisation, setOrganisation }) {
    const [canShowReportsForm, setCanShowReportsForm] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    useEffect(() => {
        setCanShowReportsForm(Boolean(organisation?.reporting));
    }, [organisation]);

    useEffect(() => {
        AuthApi.getMe().then(user => {
            setIsSuperAdmin(user?.role === 'admin');
        });
    }, []);

    const changeExcIncTax = ({ target }) => {
        setOrganisation({
            ...organisation,
            reporting: {
                ...organisation.reporting,
                includeTaxes: target.value === 'inc'
            }
        });
    };

    const changeReportingField = (field, value) => {
        setOrganisation({
            ...organisation,
            reporting: {
                ...organisation.reporting,
                [field]: value
            }
        });
    };

    if (!canShowReportsForm) return null;

    return (
        <div className={classes.reportsContainer}>
            <Typography>Default report view:</Typography>
            <RadioGroup value={organisation.reporting.includeTaxes ? 'inc' : 'exc'} onChange={changeExcIncTax} row>
                <FormControlLabel value={'inc'} control={<Radio />} label={'Inc tax'} />
                <FormControlLabel value={'exc'} control={<Radio />} label={'Ex tax'} />
            </RadioGroup>

            <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={Boolean(organisation.reporting.kpiWeeklyEnabled)}
                                onChange={({ target }) => {
                                    if (!isSuperAdmin) {
                                        toastr.error('Only super admin can change this setting');
                                        return;
                                    }
                                    changeReportingField('kpiWeeklyEnabled', target.checked);
                                }}
                                color="primary"
                            />
                        }
                        label="Email end of week KPI report"
                        style={{ minWidth: 290, marginRight: 16, marginBottom: 0 }}
                    />
                    {organisation.reporting.kpiWeeklyEnabled && (
                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Enter recipient emails separated by commas"
                            value={organisation.reporting.kpiWeeklyRecipients || ''}
                            onChange={({ target }) => changeReportingField('kpiWeeklyRecipients', target.value)}
                            style={{ flex: 1, maxWidth: 400 }}
                            InputProps={{ style: { fontSize: 14 } }}
                        />
                    )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={Boolean(organisation.reporting.kpiMonthlyEnabled)}
                                onChange={({ target }) => {
                                    if (!isSuperAdmin) {
                                        toastr.error('Only super admin can change this setting');
                                        return;
                                    }
                                    changeReportingField('kpiMonthlyEnabled', target.checked);
                                }}
                                color="primary"
                            />
                        }
                        label="Email end of month KPI report"
                        style={{ minWidth: 290, marginRight: 16, marginBottom: 0 }}
                    />
                    {organisation.reporting.kpiMonthlyEnabled && (
                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Enter recipient emails separated by commas"
                            value={organisation.reporting.kpiMonthlyRecipients || ''}
                            onChange={({ target }) => changeReportingField('kpiMonthlyRecipients', target.value)}
                            style={{ flex: 1, maxWidth: 400 }}
                            InputProps={{ style: { fontSize: 14 } }}
                        />
                    )}
                </div>

                {(organisation.reporting.kpiWeeklyEnabled || organisation.reporting.kpiMonthlyEnabled) && (
                    <Typography variant="body2" style={{ color: '#555', fontSize: 12 }}>
                        KPI reports are generated at 10pm on Sundays and last day of the month. The default tax setting
                        does not apply to the KPI report.
                    </Typography>
                )}
            </div>
        </div>
    );
}

export default withStyles(settingsStyles)(ReportsSettings);
